export const title = "Laporan Pengisian Minyak - Per Unit";

export const tableWidth = "w-[50.5rem]";

export const paramSettings = [
  {
    name: "dari",
    field: "tanggal_transaksi",
    type: "date",
    format: "yyyy-MM-dd 00:00:00",
    operator: ">=",
    default: new Date(),
    nullable: false,
  },
  {
    name: "sampai",
    field: "tanggal_transaksi",
    type: "date",
    format: "yyyy-MM-dd 23:59:59",
    operator: "<=",
    default: new Date(),
    nullable: false,
  },
];

export const generateDefaultReportParams = () => {
  const defaultParam = {};

  for (let param of paramSettings) {
    defaultParam[param.name] = param.default;
  }

  return defaultParam;
};

export const groupSetting = undefined;

export const columnSettings = [
  {
    name: "NO",
    field: "no",
    type: "number",
    width: "w-[3.5rem]",
    layout: "col-start-center",
  },
  {
    name: "TANGGAL",
    field: "tanggal_transaksi",
    type: "date",
    format: "dd MMM yyyy, HH:mm",
    width: "w-[11rem]",
    layout: "col-start-start",
  },
  {
    name: "JENIS",
    field: "jenis_minyak",
    type: "string",
    width: "w-[8rem]",
    layout: "col-start-start",
  },
  {
    name: "KM",
    field: "speedo_akhir",
    type: "number",
    width: "w-[7rem]",
    layout: "col-start-end",
  },
  {
    name: "@ HARGA",
    field: "harga_per_liter",
    type: "number",
    width: "w-[7rem]",
    layout: "col-start-end",
  },
  {
    name: "JLH (LTR)",
    field: "jumlah",
    type: "number",
    width: "w-[6rem]",
    layout: "col-start-end",
  },
  {
    name: "TOTAL",
    field: "total_harga",
    type: "number",
    width: "w-[8rem]",
    layout: "col-start-end",
  },
];
